
import { ISetTieuChuanActions } from "../../action-types/set-tieu-chuan/ISetTieuChuanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ISetTieuChuanReducer } from "../../reducer-model/set-tieu-chuan/ISetTieuChuanReducer";
const iniState: ISetTieuChuanReducer = {
    status: eReducerStatusBase.is_not_initialization,
    setTieuChuans: []
}
export const setTieuChuanReducer = (state: ISetTieuChuanReducer = iniState, action: ISetTieuChuanActions): ISetTieuChuanReducer => {
    switch (action.type) {
        case "SET_TIEU_CHUAN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SET_TIEU_CHUAN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                setTieuChuans: action.payload
            }
        case "SET_TIEU_CHUAN_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SET_TIEU_CHUAN_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                setTieuChuanEditing: action.payload,
                setTieuChuanSelectedId: 0
            }
        case "SET_TIEU_CHUAN_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "SET_TIEU_CHUAN_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SET_TIEU_CHUAN_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                setTieuChuanSelectedId: 0,
                status: eReducerStatusBase.is_need_reload,
                
            }
        case "SET_TIEU_CHUAN_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SET_TIEU_CHUAN_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "SET_TIEU_CHUAN_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "SET_TIEU_CHUAN_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SET_TIEU_CHUAN_CHANGE_SELECTED_ID":
            return {
                ...state,
                setTieuChuanSelectedId: action.payload
            }
        default:
            return state;
    }
}